import { convertNanosecondTimestampToDate } from '#services';
import { PATH_SEPARATOR } from '../constants';
export const splitIntoPrefixes = (path) => {
    const parts = path.split(PATH_SEPARATOR).filter(Boolean);
    return parts.map((_, i) => parts.slice(0, i + 1).join(PATH_SEPARATOR));
};
export const getLastPathSegment = (path) => path.slice(path.lastIndexOf(PATH_SEPARATOR) + 1);
export const joinPath = (parentPath, name) => [...parentPath.split(PATH_SEPARATOR).filter(Boolean), name].join(PATH_SEPARATOR);
export const findOpenedDirPath = ({ crumbPrefixes, crumbs, currentDirContents, currentDirPath, dirId, }) => {
    if (currentDirPath !== undefined) {
        const entry = currentDirContents?.find(({ key }) => key.id === dirId);
        if (entry) {
            return joinPath(currentDirPath, entry.name);
        }
    }
    // crumbs[0] is the root, so crumbs[i] maps to crumbPrefixes[i - 1]
    const crumbIndex = crumbs?.findIndex(({ id }) => id === dirId) ?? -1;
    return crumbIndex > 0 ? crumbPrefixes[crumbIndex - 1] : undefined;
};
export const buildCrumbs = ({ prefixes, prefixKeys, rootCrumb, }) => {
    const crumbs = [rootCrumb];
    for (const [i, path] of prefixes.entries()) {
        const key = prefixKeys[i];
        if (!key) {
            break;
        }
        crumbs.push({ id: key.id, name: getLastPathSegment(path), path });
    }
    return crumbs;
};
export const remapFsEntryToBrowserEntry = (entry) => ({
    creationTime: convertNanosecondTimestampToDate(entry.meta.creationTime).getTime(),
    data: entry.state,
    id: entry.key.id,
    name: entry.name,
    size: Number(entry.meta.size),
    type: entry.key.type,
    updateTime: convertNanosecondTimestampToDate(entry.meta.updateTime).getTime(),
});
